import { css } from 'lit';
export default css `
  .container {
    max-height: 360px;
    overflow: auto;
  }

  .container::-webkit-scrollbar {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map